// @ts-ignore

// @ts-ignore
import bold from './fonts/Product_Sans_Bold.ttf'
import regular from './fonts/ProductSansRegular.ttf'

export const FONT_MAIN = `
  @font-face {
    font-family: 'Product Sans';
    src: url(${regular}) format('opentype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Product Sans';
    src: url(${bold}) format('opentype');
    font-weight: bold;
    font-style: normal;
  }
`
